<template>
  <div class="reset-password">
    <div class="row">
      <div class="col-lg-6 col-lg-offset-3">
        <div class="box">
          <div class="box-body">
            <h2>Reset password</h2>
              <br/><br/>
              <p>Enter a new password below:</p><br/>
              <p>
                <div class="form-horizontal">
                  <password-confirm-input v-bind:field.sync="passwordInput"></password-confirm-input>
              </p>
            </div>
            <div v-if="error" class="form-section-danger">
              <p>{{ error }}</p>
            </div>
            <p class="text-right"><button @click="changePassword()" class="btn btn-default">Save</button></p>

            <hr/>
            <p>If you have any questions, just give us a call at
              <a href="tel:1300575878">1300 575 878</a> or you can email
              <a href="mailto:info@greensharecar.com.au" class="email">
                info@greensharecar.com.au</a>. We're always happy to help!</p>
            <p><img v-bind:src="'https://techcar-dev.s3.amazonaws.com/'+ ( $root.companyLogo ? $root.companyLogo : 'spacer.gif' ) + '?v=' + new Date().getTime()" v-bind:alt="companyName" /><br/> </p></center>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import PasswordConfirmInput from './inputs/PasswordConfirmInput.vue'
export default {
  name: 'ResetPassword',
  components: {
    PasswordConfirmInput
  },
  data () {
    return {
      passwordInput: {
        name: 'password',
        label: 'New Password',
        required: true,
        value: '',
        confirmation: true,
        valid: false,
        dirty: false
      },
      account: {},
      error: false
    }
  },
  ready () {
  },
  route: {
    data () {
      this.$http.post('public/check-token', { token: this.$route.params.resetToken }).then((response, status, request) => {
        if (response.data.error) {
          this.$root.$route.router.go('/404')
        } else {
          this.account = response.data
        }
      })
    }
  },
  methods: {
    changePassword () {
      this.error = false
      if (this.passwordInput.valid) {
        this.$http.post('public/form', { password: this.passwordInput.value, permalink: 'editPassword', accountUuid: this.account.uuid }).then((response, status, request) => {
          this.$root.$route.router.go('/')
        })
      } else {
        this.error = 'You did not fill in all fields correctly.'
      }
    }
  }
}
  </script>



// WEBPACK FOOTER //
// ResetPassword.vue?66f0fbbe